var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    [
      _c("v-card-title", { staticClass: "grey lighten-4 p-2" }, [
        _c("h4", { staticClass: "m-0" }, [_vm._v("Contact information")]),
        _c("h5", { staticClass: "mb-0 ml-3 text-danger" }, [
          _vm._v("(Billing Address)")
        ])
      ]),
      _vm._v(" "),
      _c(
        "v-row",
        { staticClass: "m-2" },
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "h5",
                [
                  _c("v-icon", [_vm._v("mdi-account")]),
                  _vm._v("\n                Basic info\n            ")
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "4", sm: "6" } },
                    [
                      _c("with-validation", {
                        attrs: { field: "first_name" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(ref) {
                              var bind = ref.bind
                              var on = ref.on
                              return [
                                _c(
                                  "v-text-field",
                                  _vm._g(
                                    _vm._b(
                                      {
                                        attrs: {
                                          autocomplete: _vm.autofillStatus
                                            ? "kiosk_first_name"
                                            : "off"
                                        }
                                      },
                                      "v-text-field",
                                      bind,
                                      false
                                    ),
                                    on
                                  )
                                )
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "4", sm: "6" } },
                    [
                      _c("with-validation", {
                        attrs: { field: "last_name" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(ref) {
                              var bind = ref.bind
                              var on = ref.on
                              return [
                                _c(
                                  "v-text-field",
                                  _vm._g(
                                    _vm._b(
                                      {
                                        attrs: {
                                          autocomplete: _vm.autofillStatus
                                            ? "kiosk_last_name"
                                            : "off"
                                        },
                                        on: {
                                          keydown: function($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "enter",
                                                13,
                                                $event.key,
                                                "Enter"
                                              ) &&
                                              _vm._k(
                                                $event.keyCode,
                                                "tab",
                                                9,
                                                $event.key,
                                                "Tab"
                                              )
                                            ) {
                                              return null
                                            }
                                            return _vm.processTags($event)
                                          }
                                        }
                                      },
                                      "v-text-field",
                                      bind,
                                      false
                                    ),
                                    on
                                  )
                                )
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  !_vm.is_international_canadian ||
                  (_vm.is_international_canadian &&
                    _vm.enable_international_customer)
                    ? _c(
                        "v-col",
                        { attrs: { cols: "12", md: "4", sm: "6" } },
                        [
                          _c("with-validation", {
                            attrs: {
                              context: _vm.self(),
                              field: "is_international_customer"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var bind = ref.bind
                                    var on = ref.on
                                    return [
                                      _c(
                                        "v-checkbox",
                                        _vm._g(
                                          _vm._b(
                                            {
                                              staticClass: "d-inline-flex",
                                              attrs: {
                                                "true-value": true,
                                                "false-value": false
                                              }
                                            },
                                            "v-checkbox",
                                            bind,
                                            false
                                          ),
                                          on
                                        )
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              1910341661
                            )
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "4", sm: "6" } },
                    [
                      _c(
                        "v-slide-x-transition",
                        [
                          _c("with-validation", {
                            attrs: { context: _vm.self(), field: "country" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(ref) {
                                  var bind = ref.bind
                                  var on = ref.on
                                  return [
                                    _vm.reservation.is_international_customer
                                      ? _c(
                                          "v-autocomplete",
                                          _vm._g(
                                            _vm._b(
                                              {
                                                ref: "country_select",
                                                attrs: {
                                                  autocomplete: _vm.autofillStatus
                                                    ? "kiosk_country"
                                                    : "off",
                                                  items: _vm.countries,
                                                  "item-text": "name",
                                                  "item-value": "code"
                                                }
                                              },
                                              "v-autocomplete",
                                              bind,
                                              false
                                            ),
                                            on
                                          )
                                        )
                                      : _vm._e()
                                  ]
                                }
                              }
                            ])
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "h5",
                [
                  _c("v-icon", [_vm._v("mdi-map-marker")]),
                  _vm._v("\n                Address info\n            ")
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "6" } },
                    [
                      _c("with-validation", {
                        attrs: {
                          context: _vm.self(),
                          field: "address_primary"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(ref) {
                              var bind = ref.bind
                              var on = ref.on
                              return [
                                _c(
                                  "v-text-field",
                                  _vm._g(
                                    _vm._b(
                                      {
                                        ref: "address_primary_ref",
                                        attrs: {
                                          autocomplete: _vm.autofillStatus
                                            ? "kiosk_address_primary"
                                            : "off"
                                        }
                                      },
                                      "v-text-field",
                                      bind,
                                      false
                                    ),
                                    on
                                  )
                                )
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "4" } },
                    [
                      _c("with-validation", {
                        attrs: { context: _vm.self(), field: "city" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(ref) {
                              var bind = ref.bind
                              var on = ref.on
                              return [
                                _c(
                                  "v-text-field",
                                  _vm._g(
                                    _vm._b(
                                      {
                                        attrs: {
                                          autocomplete: _vm.autofillStatus
                                            ? "kiosk_city"
                                            : "off"
                                        }
                                      },
                                      "v-text-field",
                                      bind,
                                      false
                                    ),
                                    on
                                  )
                                )
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  !_vm.reservation.is_international_customer &&
                  !_vm.is_international_canadian
                    ? [
                        _c("v-col", { attrs: { cols: "12", md: "4" } }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "v-select__slot cus-mt-5 cus-animation",
                              on: {
                                click: function($event) {
                                  return $event.stopPropagation()
                                }
                              }
                            },
                            [
                              _c(
                                "label",
                                {
                                  staticClass:
                                    "cus-select-label v-label v-label--active theme--light",
                                  attrs: { for: "state", id: "stateLabel" }
                                },
                                [_vm._v("State")]
                              ),
                              _vm._v(" "),
                              _c("with-validation", {
                                attrs: { context: _vm.self(), field: "state" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var bind = ref.bind
                                        var on = ref.on
                                        return [
                                          _c(
                                            "select",
                                            {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.reservation.state,
                                                  expression:
                                                    "reservation.state"
                                                }
                                              ],
                                              staticClass:
                                                "cus-select form-control smaller-list v-text-field v-select__selection--comma v-select",
                                              attrs: {
                                                name: "state",
                                                id: "state"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.addAnimation(
                                                    "stateLabel"
                                                  )
                                                },
                                                change: function($event) {
                                                  var $$selectedVal = Array.prototype.filter
                                                    .call(
                                                      $event.target.options,
                                                      function(o) {
                                                        return o.selected
                                                      }
                                                    )
                                                    .map(function(o) {
                                                      var val =
                                                        "_value" in o
                                                          ? o._value
                                                          : o.value
                                                      return val
                                                    })
                                                  _vm.$set(
                                                    _vm.reservation,
                                                    "state",
                                                    $event.target.multiple
                                                      ? $$selectedVal
                                                      : $$selectedVal[0]
                                                  )
                                                }
                                              }
                                            },
                                            _vm._l(_vm.states, function(
                                              item,
                                              key
                                            ) {
                                              return _c(
                                                "option",
                                                {
                                                  key: key,
                                                  domProps: {
                                                    value: item.abbreviation
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                        " +
                                                      _vm._s(item.name) +
                                                      "\n                                    "
                                                  )
                                                ]
                                              )
                                            }),
                                            0
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  3552186800
                                )
                              })
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "v-col",
                          { attrs: { cols: "12", md: "4" } },
                          [
                            _c("with-validation", {
                              attrs: { context: _vm.self(), field: "zip" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(ref) {
                                      var bind = ref.bind
                                      var on = ref.on
                                      return [
                                        _c(
                                          "v-text-field",
                                          _vm._g(
                                            _vm._b(
                                              {
                                                key: "zip_input",
                                                attrs: {
                                                  autocomplete: _vm.autofillStatus
                                                    ? "kiosk_zip"
                                                    : "off"
                                                }
                                              },
                                              "v-text-field",
                                              bind,
                                              false
                                            ),
                                            on
                                          )
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                1276845035
                              )
                            })
                          ],
                          1
                        )
                      ]
                    : [
                        _vm.is_international_canadian &&
                        !_vm.reservation.is_international_customer
                          ? [
                              _c("v-col", { attrs: { cols: "12", md: "4" } }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "v-select__slot cus-mt-5 cus-animation",
                                    on: {
                                      click: function($event) {
                                        return $event.stopPropagation()
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "label",
                                      {
                                        staticClass:
                                          "cus-select-label v-label v-label--active theme--light",
                                        attrs: {
                                          for: "province",
                                          id: "provinceLabel"
                                        }
                                      },
                                      [_vm._v("Province")]
                                    ),
                                    _vm._v(" "),
                                    _c("with-validation", {
                                      attrs: {
                                        context: _vm.self(),
                                        field: "province"
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function(ref) {
                                              var bind = ref.bind
                                              var on = ref.on
                                              return [
                                                _c(
                                                  "select",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.reservation
                                                            .province,
                                                        expression:
                                                          "reservation.province"
                                                      }
                                                    ],
                                                    staticClass:
                                                      "cus-select form-control smaller-list v-text-field v-select__selection--comma v-select",
                                                    attrs: {
                                                      name: "state",
                                                      id: "province"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.addAnimation(
                                                          "provinceLabel"
                                                        )
                                                      },
                                                      change: function($event) {
                                                        var $$selectedVal = Array.prototype.filter
                                                          .call(
                                                            $event.target
                                                              .options,
                                                            function(o) {
                                                              return o.selected
                                                            }
                                                          )
                                                          .map(function(o) {
                                                            var val =
                                                              "_value" in o
                                                                ? o._value
                                                                : o.value
                                                            return val
                                                          })
                                                        _vm.$set(
                                                          _vm.reservation,
                                                          "province",
                                                          $event.target.multiple
                                                            ? $$selectedVal
                                                            : $$selectedVal[0]
                                                        )
                                                      }
                                                    }
                                                  },
                                                  _vm._l(_vm.states, function(
                                                    item,
                                                    key
                                                  ) {
                                                    return _c(
                                                      "option",
                                                      {
                                                        key: key,
                                                        domProps: {
                                                          value:
                                                            item.abbreviation
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                                            " +
                                                            _vm._s(item.name) +
                                                            "\n                                        "
                                                        )
                                                      ]
                                                    )
                                                  }),
                                                  0
                                                )
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        false,
                                        2901877981
                                      )
                                    })
                                  ],
                                  1
                                )
                              ])
                            ]
                          : [
                              _c(
                                "v-col",
                                { attrs: { cols: "12", md: "4" } },
                                [
                                  _c("with-validation", {
                                    attrs: {
                                      context: _vm.self(),
                                      field: "province"
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function(ref) {
                                          var bind = ref.bind
                                          var on = ref.on
                                          return [
                                            _c(
                                              "v-text-field",
                                              _vm._g(
                                                _vm._b(
                                                  {
                                                    attrs: {
                                                      autocomplete: _vm.autofillStatus
                                                        ? "kiosk_province"
                                                        : "off"
                                                    }
                                                  },
                                                  "v-text-field",
                                                  bind,
                                                  false
                                                ),
                                                on
                                              )
                                            )
                                          ]
                                        }
                                      }
                                    ])
                                  })
                                ],
                                1
                              )
                            ],
                        _vm._v(" "),
                        _c(
                          "v-col",
                          { attrs: { cols: "12", md: "4" } },
                          [
                            _c("with-validation", {
                              attrs: {
                                context: _vm.self(),
                                field: "postal_code"
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var bind = ref.bind
                                    var on = ref.on
                                    return [
                                      _c(
                                        "v-text-field",
                                        _vm._g(
                                          _vm._b(
                                            {
                                              key: "postal_code_input",
                                              attrs: {
                                                autocomplete: _vm.autofillStatus
                                                  ? "kiosk_postal_code"
                                                  : "off"
                                              }
                                            },
                                            "v-text-field",
                                            bind,
                                            false
                                          ),
                                          on
                                        )
                                      )
                                    ]
                                  }
                                }
                              ])
                            })
                          ],
                          1
                        )
                      ]
                ],
                2
              ),
              _vm._v(" "),
              _c("v-expand-transition", [
                !_vm.reservation.is_international_customer ||
                _vm.reservation.country
                  ? _c(
                      "div",
                      [
                        _c(
                          "h5",
                          { staticClass: "mt-5" },
                          [
                            _c("v-icon", [_vm._v("mdi-card-account-phone")]),
                            _vm._v(
                              "\n                        Contact info\n                    "
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-row",
                          [
                            _c(
                              "v-col",
                              { attrs: { cols: "12", md: "4" } },
                              [
                                _c("with-validation", {
                                  attrs: {
                                    context: _vm.self(),
                                    field: "phone"
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(ref) {
                                          var bind = ref.bind
                                          var on = ref.on
                                          return [
                                            _vm.reservation
                                              .is_international_customer
                                              ? _c(
                                                  "v-text-field",
                                                  _vm._g(
                                                    _vm._b(
                                                      {
                                                        attrs: {
                                                          autocomplete: _vm.autofillStatus
                                                            ? "kiosk_phone_international_customer"
                                                            : "off"
                                                        }
                                                      },
                                                      "v-text-field",
                                                      bind,
                                                      false
                                                    ),
                                                    on
                                                  )
                                                )
                                              : _vm.is_international_canadian
                                              ? _c(
                                                  "v-text-field",
                                                  _vm._g(
                                                    _vm._b(
                                                      {
                                                        directives: [
                                                          {
                                                            name: "mask",
                                                            rawName: "v-mask",
                                                            value:
                                                              _vm.dynamicMask,
                                                            expression:
                                                              "dynamicMask"
                                                          }
                                                        ],
                                                        attrs: {
                                                          autocomplete: _vm.autofillStatus
                                                            ? "kiosk_phone"
                                                            : "off",
                                                          minlength: "15"
                                                        }
                                                      },
                                                      "v-text-field",
                                                      bind,
                                                      false
                                                    ),
                                                    on
                                                  )
                                                )
                                              : _c(
                                                  "v-text-field",
                                                  _vm._g(
                                                    _vm._b(
                                                      {
                                                        directives: [
                                                          {
                                                            name: "mask",
                                                            rawName: "v-mask",
                                                            value:
                                                              "(###) ###-####",
                                                            expression:
                                                              "'(###) ###-####'"
                                                          }
                                                        ],
                                                        attrs: {
                                                          autocomplete: _vm.autofillStatus
                                                            ? "kiosk_phone"
                                                            : "off",
                                                          minlength: "15"
                                                        }
                                                      },
                                                      "v-text-field",
                                                      bind,
                                                      false
                                                    ),
                                                    on
                                                  )
                                                )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    2832530556
                                  )
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-col",
                              { attrs: { cols: "12", md: "4" } },
                              [
                                _c("with-validation", {
                                  attrs: {
                                    context: _vm.self(),
                                    field: "email"
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(ref) {
                                          var bind = ref.bind
                                          var on = ref.on
                                          return [
                                            _c(
                                              "v-text-field",
                                              _vm._g(
                                                _vm._b(
                                                  {
                                                    attrs: {
                                                      autocomplete: _vm.autofillStatus
                                                        ? "kiosk_email"
                                                        : "off"
                                                    }
                                                  },
                                                  "v-text-field",
                                                  bind,
                                                  false
                                                ),
                                                on
                                              )
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    3439168367
                                  )
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-col",
                              { attrs: { cols: "12", md: "4" } },
                              [
                                _c("with-validation", {
                                  attrs: {
                                    context: _vm.self(),
                                    field: "email_confirmation"
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(ref) {
                                          var bind = ref.bind
                                          var on = ref.on
                                          return [
                                            _c(
                                              "v-text-field",
                                              _vm._g(
                                                _vm._b(
                                                  {
                                                    attrs: {
                                                      autocomplete: _vm.autofillStatus
                                                        ? "kiosk_email_confirmation"
                                                        : "off"
                                                    }
                                                  },
                                                  "v-text-field",
                                                  bind,
                                                  false
                                                ),
                                                on
                                              )
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    711236639
                                  )
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }